import { JsonpClientBackend } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AdminCtrlVehGeocerca } from 'src/app/models/admin-ctrlvehiculo-geocerca';
import { ControlVehiculosService } from 'src/app/services/admin/control-vehiculos-service/control-vehiculos.service';
import { ControlGeocercaService } from 'src/app/services/flota/control-geocerca-service/control-geocerca.service';
import { ConfirmDialog } from 'src/app/shared/confirmdialog/confirmdialog.component';
import { Gtp } from 'src/app/shared/gtp';

import { interval } from 'rxjs';

@Component({
  selector: 'app-control-vehiculos-mantenimiento',
  templateUrl: './control-vehiculos-mantenimiento.component.html',
  styleUrls: ['./control-vehiculos-mantenimiento.component.scss']
})
export class ControlVehiculosMantenimiento implements OnInit, OnDestroy {
  
  loading:boolean = false;
  public contClass: string = 'container-fluid maincont';
  public perfilData = {
    ultmant: null,
    kmactual: null,
    avisoxkmantes: null,
    automcada: null,
  };

  constructor(
    public gtp: Gtp,
    private ctrlVehiculo: ControlVehiculosService,
  ) {
          
  }
  
  ngOnInit(): void {
    if (this.ctrlVehiculo.mantenimientoConfig) {
      this.setInitialInfo();
    } 
  }

  ngOnDestroy():void{
    //if (this.saveInterval){ this.saveInterval.unsubscribe(); }
  }

  setInitialInfo(){
    this.perfilData.ultmant = this.ctrlVehiculo.mantenimientoConfig.ultmant;
    this.perfilData.kmactual = this.ctrlVehiculo.mantenimientoConfig.kmactual;
    this.perfilData.avisoxkmantes = this.ctrlVehiculo.mantenimientoConfig.avisoxkmantes;
    this.perfilData.automcada = this.ctrlVehiculo.mantenimientoConfig.automcada;
  }

  /**
   * Cierra la ventana del informe activa.
   */
  cerrarInforme() {
    this.gtp.cerrarVentanas(true);
  }

  /**
   * Aumenta o disminuye el tamaño del ancho en el informe.
   */
  containerSize() {
    this.contClass = this.gtp.containerSize(this.contClass);
  }
  
  saveParams(){    
    console.log(this.perfilData);
    this.perfilData = JSON.parse(JSON.stringify(this.perfilData));
    this.ctrlVehiculo.setMantenimientoConfig(this.perfilData);    
    console.log('Actualizando...');
  }

}
